import { render, staticRenderFns } from "./add-course-work-attachment-dialog.vue?vue&type=template&id=88abc2cc&scoped=true"
import script from "./add-course-work-attachment-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-course-work-attachment-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./add-course-work-attachment-dialog.vue?vue&type=style&index=0&id=88abc2cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88abc2cc",
  null
  
)

export default component.exports